import { render, staticRenderFns } from "./form.vue?vue&type=template&id=58ac163a&scoped=true"
import script from "./form.vue?vue&type=script&lang=ts"
export * from "./form.vue?vue&type=script&lang=ts"
import style0 from "./form.vue?vue&type=style&index=0&id=58ac163a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ac163a",
  null
  
)

export default component.exports